import React                               from 'react';
import {render}                            from 'react-dom';
import StatusBar                           from '../components/StatusBar/StatusBar';
import StatusBarNoAVS                      from '../components/StatusBar/StatusBarNoAVS';
import StatusBarAVSAccepted                from '../components/StatusBar/StatusBarAVSAccepted';
import StatusBarNoVerifiedEmail            from '../components/StatusBar/StatusBarNoVerifiedEmail';
import StatusBarEmailVerified              from '../components/StatusBar/StatusBarEmailVerified';
import StatusBarWelcomeBack                from '../components/StatusBar/StatusBarWelcomeBack';
import StatusBarMonthlyBonusNotification   from '../components/StatusBar/StatusBarMonthlyBonusNotification';
import StatusBarGuestCancelationOffer      from '../components/StatusBar/StatusBarGuestCancelationOffer';
import StatusBarGuestCancelationOfferError from '../components/StatusBar/StatusBarGuestCancelationOfferError';
import StatusBarError                      from '../components/StatusBar/StatusBarError';
import StatusBarAutomaticRecharge          from '../components/StatusBar/StatusBarAutomaticRecharge';
import Translations                        from './../utils/Translations';
import Constants                           from '../components/StatusBar/Constants';
import StatusBarAVSStatus                  from '../components/StatusBar/StatusBarAVSStatus';
import StatusBarNotFoundRedirect           from "../components/StatusBar/StatusBarNotFoundRedirect";
import FluxConstants                       from './../flux/Constants';

const statusBarTypes = FluxConstants.StatusBar.Types;

/*import TextArea                     from '../components/Form/FormTextarea';*/

function run(containerId, statusbarConfig) {
	const container = document.getElementById(containerId);

	const renderStatusBarGuestCancellationOfferError = () => {
		const statusBarGuestCancelationOfferError =
			      <StatusBarGuestCancelationOfferError barColor={Constants.BARCOLOR_RED}
			                                           msgOutro={Translations.get('StatusBarGuestCancellationOfferErrorOutro')}
			                                           isVisible={statusbarConfig.isStatusBarVisible}
			                                           btnLabel={Translations.get('StatusBarGuestCancellationOfferErrorButton')}
			      />;
		render(statusBarGuestCancelationOfferError, container);

	};

	const renderStatusBarGuestCancellationOfferSuccess = (data) => {
		const isVipType       = data && data.isVipAboType;
		const translationText = isVipType ? Translations.get('StatusBarGuestCancellationOfferSuccessVipAbo', new Date(data.bonusActiveTill * 1000).toLocaleDateString()) : Translations.get('StatusBarGuestCancellationOfferSuccess');

		const statusBarGuestCancelationSuccess =
			      <StatusBarWelcomeBack barColor={Constants.BARCOLOR_GREEN}
			                            msgOutro={translationText}
			                            isVisible={statusbarConfig.isStatusBarVisible}
			      />;
		render(statusBarGuestCancelationSuccess, container);
	};

	if (container) {
		let statusBar = null;

		switch (statusbarConfig.barType) {
			case statusBarTypes.BARTYPE_WELCOMEBACK_USER:
				statusBar =
					<StatusBarWelcomeBack barColor={statusbarConfig.barColor}
					                      msgOutro={statusbarConfig.outroText}
					                      isVisible={statusbarConfig.isStatusBarVisible}
					/>;
				break;

			case statusBarTypes.BARTYPE_MONTHLY_BONUS_PROCESSED_NOTIFICATION:
				statusBar =
					<StatusBarMonthlyBonusNotification barColor={statusbarConfig.barColor}
					                                   msgOutro={statusbarConfig.outroText}
					                                   isVisible={statusbarConfig.isStatusBarVisible}
					/>;
				break;
			case statusBarTypes.BARTYPE_CANCELATION_OFFER:
				statusBar =
					<StatusBarGuestCancelationOffer barColor={statusbarConfig.barColor}
					                                msgOutro={statusbarConfig.outroText}
					                                isVisible={statusbarConfig.isStatusBarVisible}
					                                guestId={statusbarConfig.guestId}
					                                offerActivationFail={renderStatusBarGuestCancellationOfferError}
					                                offerActivationSuccess={renderStatusBarGuestCancellationOfferSuccess}
					/>;
				break;
			case statusBarTypes.BARTYPE_CANCELATION_OFFER_ERROR:
				statusBar =
					<StatusBarGuestCancelationOfferError barColor={statusbarConfig.barColor}
					                                     msgOutro={statusbarConfig.outroText}
					                                     isVisible={statusbarConfig.isStatusBarVisible}
					                                     btnLabel={statusbarConfig.buttonLabel}
					/>;
				break;
			case statusBarTypes.BARTYPE_NOAVS:
				statusBar =
					<StatusBarNoAVS barColor={statusbarConfig.barColor}
					                msgOutro={statusbarConfig.outroText}
					                btnLabel={statusbarConfig.buttonLabel}
					                hideText={statusbarConfig.hideText}
					                isVisible={statusbarConfig.isStatusBarVisible}
					                options={statusbarConfig.optionalFields}
					/>;
				break;
			case statusBarTypes.BARTYPE_AVS_STATUS:
				statusBar =
					<StatusBarAVSStatus barColor={statusbarConfig.barColor}
					                    hideText={statusbarConfig.hideText}
					                    isVisible={statusbarConfig.isStatusBarVisible}
					                    options={statusbarConfig.optionalFields}
					/>;
				break;
			case statusBarTypes.BARTYPE_AVS_ACCEPTED:
				statusBar =
					<StatusBarAVSAccepted barColor={statusbarConfig.barColor}
					                      msgOutro={statusbarConfig.outroText}
					                      hideText={statusbarConfig.hideText}
					                      isVisible={statusbarConfig.isStatusBarVisible}
					                      options={statusbarConfig.optionalFields}
					/>;
				break;
			case statusBarTypes.BARTYPE_MAILNOTVERIFIED:
				statusBar =
					<StatusBarNoVerifiedEmail barColor={statusbarConfig.barColor}
					                          msgIntro={statusbarConfig.introText}
					                          msgOutro={statusbarConfig.outroText}
					                          isVisible={statusbarConfig.isStatusBarVisible}
					                          sendWelcomeMailButtonLbl={statusbarConfig.sendWelcomeMailButtonLbl}
					                          sendWelcomeMailChangeMailText={statusbarConfig.sendWelcomeMailChangeMailText}
					                          sendWelcomeMailText={statusbarConfig.sendWelcomeMailText}
					                          options={[]}
					>
					</StatusBarNoVerifiedEmail>;
				break;
			case statusBarTypes.BARTYPE_VERIFIEDMAIL:
				statusBar =
					<StatusBarEmailVerified
						barColor={statusbarConfig.barColor}
						btnLabel={statusbarConfig.buttonLabel}
						msgIntro={statusbarConfig.introText}
						msgOutro={statusbarConfig.outroText}
						targetUrl={statusbarConfig.targetUrl}
						isVisible={statusbarConfig.isStatusBarVisible}
						hasFreeClip={true}
						options={[]}
					/>;
				break;
			case statusBarTypes.BARTYPE_MAILWELCOMELINK:
				statusBar =
					<StatusBarEmailVerified
						barColor={statusbarConfig.barColor}
						btnLabel={statusbarConfig.buttonLabel}
						msgIntro={statusbarConfig.introText}
						msgOutro={statusbarConfig.outroText}
						targetUrl={statusbarConfig.targetUrl}
						isVisible={statusbarConfig.isStatusBarVisible}
						hasFreeClip={statusbarConfig.hasFreeClip}
						options={[]}
					/>;
				break;
			case statusBarTypes.BARTYPE_ERROR:
				statusBar =
					<StatusBarError
						barColor={statusbarConfig.barColor}
						btnLabel={statusbarConfig.buttonLabel}
						msgIntro={statusbarConfig.introText}
						msgOutro={statusbarConfig.outroText}
						isVisible={statusbarConfig.isStatusBarVisible}
					/>;
				break;
			case statusBarTypes.BARTYPE_AUTOMATIC_RECHARGE:
				statusBar =
					<StatusBarAutomaticRecharge
						barColor={statusbarConfig.barColor}
						hideText={statusbarConfig.hideText}
						btnLabel={statusbarConfig.buttonLabel}
						msgIntro={statusbarConfig.introText}
						msgOutro={statusbarConfig.outroText}
						isVisible={statusbarConfig.isStatusBarVisible}
					/>;
				break;
			case statusBarTypes.BARTYPE_NOT_FOUND_REDIRECT:
				statusBar =
					<StatusBarNotFoundRedirect
						barColor={statusbarConfig.barColor}
						hideText={statusbarConfig.hideText}
						btnLabel={statusbarConfig.buttonLabel}
						msgIntro={statusbarConfig.introText}
						msgOutro={statusbarConfig.outroText}
						isVisible={statusbarConfig.isStatusBarVisible}
					/>;
				break;
			default:
				statusBar =
					<StatusBar guestName={statusbarConfig.guestName}
					           barColor={statusbarConfig.barColor}
					           msgIntro={statusbarConfig.introText}
					           msgOutro={statusbarConfig.outroText}
					           btnLabel={statusbarConfig.buttonLabel}
					           isVisible={statusbarConfig.isStatusBarVisible}
					           options={statusbarConfig.optionalFields}
					/>;
		}
		/*
		const children = options.map(
			function (item) {
				let elem;
				switch (item.type) {
					case 'input':
						elem = <Input name={item.name} value={item.value} tooltip={item.tooltip} placeholder={item.placeholder} onValueChange={item.function} />;
						break;
					case 'textarea':
						elem = <TextArea name={item.name} tooltip={item.tooltip} value={item.value} placeholder={item.placeholder}rows={item.rows} maxLength={item.maxLength} onValueChange={item.function} />;
						break;
					default:
						elem = '';
				}
				return <div className={item.colclass}>{item.content} {elem}</div>;
			}
		);
		*/
		render(statusBar, container);
	}
}

export {run};
